export const TEMA_DEFAULT = {
  '--color-white': '#ffffff',
  '--color-background-grey': '#f8fafc',
  '--color-font-grey': '#6b7280',
  '--color-border-grey': '#d1d5db',
  '--color-button-disabled': '#e2e8f0',
  '--color-title-black': '#0a0a0a',
  '--color-text': '#27272a',
  '--primary-color': '#13aff3',
  '--icon-main-color': '#13aff3',
  '--hover-button-color': '#33c1ff',
  '--background-selected-blue': '#1093cc',
  '--hover-color': '#11a1df6b',
  '--hover-secundario-bg': '#e7ebef',
  '--text-hover-color': '#ffffffd9',
  '--font-grey-hover': '#555b66',
  '--color-grey': '#618097',
  '--color-orange': '#cd2e00',
  '--disabled-button-color': '#e2e8f0'
} as const;

export const TEMA_MOSTEN = {
  ...TEMA_DEFAULT,
  '--hover-button-color': '#7a45d4',
  '--primary-color': '#612CB5',
  '--icon-main-color': '#612CB5',
  '--background-selected-blue': '#4e2294',
  '--hover-color': '#612cb56b'
} as const;
